import React from "react";
import { AntDesign, FontAwesome, FontAwesome5 } from "@expo/vector-icons";
import VDBCustomIcon from "@components/icons/VDBCustomIcon";
import { Image, ImageResizeMode } from "react-native";
import { SvgUri } from "react-native-svg";
import { Image as ExpoImage } from "expo-image";
import { useFontContext } from "../../contexts/FontContext";

export enum IconsVariant {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  AntDesign,
  // eslint-disable-next-line @typescript-eslint/no-shadow
  FontAwesome,
  // eslint-disable-next-line @typescript-eslint/no-shadow
  FontAwesome5,
  VDBCustom,
  CustomUrl,
}

export enum IconsType {
  img = "img",
  svg = "svg",
  img_url = "img-url",
  svg_url = "svg-url",
  url = "url",
}

export interface IconProps {
  variant: IconsVariant;
  name:
    | React.ComponentProps<typeof AntDesign>["name"]
    | React.ComponentProps<typeof FontAwesome>["name"]
    | React.ComponentProps<typeof FontAwesome5>["name"]
    | React.ComponentProps<typeof VDBCustomIcon>["name"];
  color?: string;
  size?: number;
  uri?: string;
  height?: number;
  resizeMode?: ImageResizeMode;
}

export interface CustomIconProps extends IconProps {
  others?: object;
  avoidSVGCheck?: boolean;
  thumbSize?: number;
}

const VDBIcon = ({
  variant,
  name,
  size = 16,
  height,
  color,
  uri,
  others = {},
  resizeMode = "contain",
  avoidSVGCheck = false,
  thumbSize,
}: CustomIconProps) => {
  const { fontsLoaded } = useFontContext();
  const isSvg = uri?.split(".")?.includes("svg") && !avoidSVGCheck && SvgUri;
  const isGif = uri?.split(".")?.includes("gif");
  const normalizedName = name?.toLowerCase();

  switch (variant) {
    case IconsVariant.AntDesign:
      if (!fontsLoaded) return null;
      return (
        <AntDesign
          name={normalizedName}
          color={color}
          size={size}
          {...others}
        />
      );
    case IconsVariant.FontAwesome:
      if (!fontsLoaded) return null;
      return (
        <FontAwesome
          name={normalizedName}
          color={color}
          size={size}
          {...others}
        />
      );
    case IconsVariant.FontAwesome5:
      if (!fontsLoaded) return null;
      return (
        <FontAwesome5
          name={normalizedName}
          color={color}
          size={size}
          {...others}
        />
      );
    case IconsVariant.VDBCustom:
      return (
        <VDBCustomIcon
          name={normalizedName}
          size={size}
          color={color}
          {...others}
        />
      );
    case IconsVariant.CustomUrl:
      if (!uri) {
        return null;
      }

      if (isSvg) {
        return <SvgUri width={size} height={size} uri={uri} fill={color} />;
      }

      if (isGif) {
        return (
          <ExpoImage
            source={uri}
            style={{ width: thumbSize, height: thumbSize }}
            contentFit="contain"
          />
        );
      }

      return (
        <Image
          style={{ width: size, height: height ?? size }}
          source={{ uri }}
          resizeMode={resizeMode}
        />
      );
    default:
      return null;
  }
};

export default VDBIcon;
